import { useLocation } from 'react-router-dom';
import { getUser } from '../utils/auth';

const Username = () => {
    const location = useLocation();
    const user = getUser()
    console.log("decodeJWT", user)

  // Map routes to titles or derive dynamically
  const getTitle = (pathname) => {
    const path = pathname.replace(/^\/+/, '');
    if (!path) return 'Matrimonial';
    switch (path) {
      case 'about':
        return 'About';
      default:
        return path.charAt(0).toUpperCase() + path.slice(1).toLowerCase();
    }
  };

  const title = getTitle(location.pathname);


  return (
    <div className="flex items-center justify-between p-4 bg-gradient-to-b from-blue-700 via-blue-700 to-blue-600 text-white">
      <div className="w-1/3"></div>
      <div className="w-1/3 text-center">
        <h1 className="text-4xl font-semibold">{title}</h1>
      </div>
      {user?.name && (
        <div className="w-1/3 text-end">
          <span className="text-xl font-semibold text-white">
            {user?.name}
          </span>
        </div>
      )}
    </div>
  );
};

export default Username;
